import { CalendarCheck, Clock, MapPin, Navigation, Phone, ShoppingBag } from "lucide-react";
import { ADDRESS, BOOK_URL, DIRECTIONS_URL, HOURS, MAPS_EMBED, ORDER_URL, PHONE_DISPLAY, PHONE_TEL } from "./data";

export default function Location() {
  return (
    <section id="contact" data-testid="location-contact-section" className="scroll-mt-20 py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#E86A24]">Visit Us</p>
          <h2 className="mt-3 font-display text-2xl font-semibold tracking-tight text-[#3A2C1E] sm:text-3xl lg:text-4xl">
            Location, Hours & Contact
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-5">
          <div className="overflow-hidden rounded-2xl border border-[#C97B5F]/20 shadow-[0_20px_60px_rgba(0,0,0,0.5)] lg:col-span-3">
            <iframe
              title="Curry Story Indian Restaurant location map"
              data-testid="google-maps-embed"
              src={MAPS_EMBED}
              className="h-[320px] w-full sm:h-[420px] lg:h-full"
              style={{ border: 0, filter: "grayscale(0.2) contrast(1.05)" }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="flex flex-col gap-4 lg:col-span-2">
            <div className="card-glow rounded-2xl border border-[#C97B5F]/15 bg-white p-6">
              <div className="flex items-start gap-3.5">
                <MapPin size={18} className="mt-0.5 shrink-0 text-[#8A3324]" />
                <div>
                  <h3 className="text-sm font-bold text-[#3A2C1E]">Address</h3>
                  <p data-testid="location-address-text" className="mt-1 text-sm text-stone-500">{ADDRESS}</p>
                  <a
                    href={DIRECTIONS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="location-get-directions-button"
                    className="mt-3 inline-flex items-center gap-2 rounded-full border border-[#C97B5F]/40 px-4 py-2 text-[11px] font-bold uppercase tracking-widest text-[#8A3324] transition-colors duration-200 hover:bg-[#D4A359] hover:text-[#0B0807]"
                  >
                    <Navigation size={13} /> Get Directions
                  </a>
                </div>
              </div>
              <div className="mt-6 flex items-start gap-3.5 border-t border-[#C97B5F]/10 pt-6">
                <Phone size={18} className="mt-0.5 shrink-0 text-[#8A3324]" />
                <div>
                  <h3 className="text-sm font-bold text-[#3A2C1E]">Phone</h3>
                  <p className="mt-1 text-sm text-stone-500">{PHONE_DISPLAY}</p>
                  <a
                    href={PHONE_TEL}
                    data-testid="location-click-to-call-button"
                    className="mt-3 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#E86A24] to-[#B82E1F] px-4 py-2 text-[11px] font-bold uppercase tracking-widest text-white shadow-lg shadow-[#E86A24]/25 transition-transform duration-200 hover:scale-[1.03]"
                  >
                    <Phone size={13} /> Call Now
                  </a>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-[#C97B5F]/15 bg-white p-6">
              <h3 className="flex items-center gap-2.5 text-sm font-bold text-[#3A2C1E]">
                <Clock size={16} className="text-[#8A3324]" /> Opening Hours
              </h3>
              <ul data-testid="opening-hours-list" className="mt-4 space-y-2">
                {HOURS.map((h) => (
                  <li key={h.day} className="flex items-center justify-between text-sm">
                    <span className="text-stone-500">{h.day}</span>
                    <span className="font-medium text-[#3A2C1E]/90">{h.time}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex gap-3">
              <a
                href={ORDER_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-order-online-button"
                className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#E86A24] to-[#B82E1F] py-3.5 text-xs font-bold uppercase tracking-widest text-white shadow-lg shadow-[#E86A24]/30 transition-transform duration-200 hover:scale-[1.02]"
              >
                <ShoppingBag size={14} /> Order
              </a>
              <a
                href={BOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-book-table-button"
                className="flex flex-1 items-center justify-center gap-2 rounded-full border border-[#C97B5F] py-3.5 text-xs font-bold uppercase tracking-widest text-[#8A3324] transition-colors duration-200 hover:bg-[#D4A359]/10"
              >
                <CalendarCheck size={14} /> Book
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
